declare const window: any; // Add this error while adding window properties

export function mobileApp(data = {}) {
    if(window.ReactNativeWebView){
        window.ReactNativeWebView?.postMessage(JSON.stringify(data))
    }
}